import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { BSelect } from 'common/components';
import { connect } from 'react-redux';
import { segmentsRequest } from 'RootModule/redux/actions/catalogs';

function Segmentation(props) {
  const {
    segmentation,
    segmentsRequest: getSegments,
    askFromService,
    label,
    name,
    onSuccess,
    ...other
  } = props;

  useEffect(() => {
    if (askFromService) getSegments({ onSuccess });
  }, [getSegments, askFromService, onSuccess]);

  return (
    <BSelect
      isLoading={segmentation.isLoading}
      name={name}
      label={label}
      options={segmentation.data}
      {...other}
    />
  );
}

Segmentation.propTypes = {
  label: PropTypes.string,
  segmentsRequest: PropTypes.func,
  segmentation: PropTypes.object,
  askFromService: PropTypes.bool,
  onSuccess: PropTypes.func,
};

Segmentation.defaultProps = {
  label: 'Segmentación',
  segmentsRequest: null,
  segmentation: { data: [], isLoading: false },
  askFromService: true,
  onSuccess: null,
};

function mapStateToProps(state) {
  return {
    segmentation: state.APP?.catalogs?.segmentation,
  };
}

export default connect(mapStateToProps, { segmentsRequest })(Segmentation);
